import { render } from "./AnswerDeleteModal.vue?vue&type=template&id=0a33722c&scoped=true&ts=true"
import script from "./AnswerDeleteModal.vue?vue&type=script&lang=ts"
export * from "./AnswerDeleteModal.vue?vue&type=script&lang=ts"

import "./AnswerDeleteModal.vue?vue&type=style&index=0&id=0a33722c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a33722c"]])

export default __exports__